// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"458864d1","139":"4b679b94","319":"25706a27","580":"e10ed367","682":"8c7f75d6","713":"5295ddf0","981":"c91938a7"}[chunkId] + ".chunk.js";
};